import { getFeatureConfig } from '@luna/feature-config';
import type { Language, LanguageVariant } from '@luna/i18n';

export function resolveLanguageOverrides(language: Language): LanguageVariant {
    const { languageOverrides, languageScriptOverrides } = getFeatureConfig(
        (featureConfig) => featureConfig.base,
    );

    if (languageOverrides?.[language]) {
        return languageOverrides[language];
    }

    if (languageScriptOverrides?.[language]) {
        return languageScriptOverrides[language];
    }

    return language;
}
